import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageSectionBase } from 'shared/components/ui/page-section-base';
import { useListColumns } from 'shared/hooks/use-list-columns';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { LimitKeys } from 'shared/types/limit-keys';

import { useInsightsHabits } from '../../hooks/use-insights-habits';
import { EmptyMessage } from '../empty-message';
import { HabitInsightsCard } from '../habit-insights-card';
import { InsightsPremiumBanner } from '../insights-premium-banner';
import * as Styled from './habits-insights.style';

export const HabitsInsights: React.FC = () => {
  const widthRef = React.useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const habits = useInsightsHabits();
  const { allowed } = usePremiumFeatureAllowed(LimitKeys.Insights, {});

  const listColumns = useListColumns(widthRef);

  return (
    <PageSectionBase
      title={t('pages.insights.sections.habits.title')}
      fullSize={!habits.length}
      noPadding
    >
      {habits.length ? (
        <>
          <Styled.WidthRef ref={widthRef} />
          <Styled.List $columns={listColumns}>
            {habits.map((habit) => (
              <Styled.ListItem $columns={listColumns} key={habit.id}>
                <HabitInsightsCard habit={habit} />
              </Styled.ListItem>
            ))}

            {!allowed && (
              <Styled.PremiumBannerContainer>
                <InsightsPremiumBanner />
              </Styled.PremiumBannerContainer>
            )}
          </Styled.List>
        </>
      ) : (
        <EmptyMessage />
      )}
    </PageSectionBase>
  );
};
